import React from 'react';
import { useTranslation } from 'react-i18next';
import usdcIcon from '../../../../images/icons/USDC.png';

const AccountCard = ({ packageData, isSelected, onSelect }) => {
  const { t } = useTranslation();
  
  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(price);
  };

  const formatAmount = (amount) => {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  const headerStyle = {
    background: isSelected 
      ? 'linear-gradient(135deg, #00c087 0%, #00a876 100%)' 
      : 'linear-gradient(135deg, #1e2541 0%, #16192e 100%)',
    margin: 0,
    padding: '32px 24px'
  };

  const buttonStyle = {
    background: 'linear-gradient(135deg, #00c087 0%, #00a876 100%)',
    color: '#ffffff',
    border: `2px solid #00c087`,
    padding: '14px 28px',
    borderRadius: '16px',
    fontSize: '15px',
    fontWeight: '700',
    cursor: packageData.isActive ? 'pointer' : 'not-allowed',
    width: '220px',
    opacity: packageData.isActive ? 1 : 0.5,
    boxShadow: '0 8px 24px rgba(0, 192, 135, 0.4), 0 0 40px rgba(0, 192, 135, 0.2)',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    position: 'relative',
    overflow: 'hidden'
  };

  return (
    <div className="account-card">
      {!packageData.isActive && (
        <div className="account-card-overlay">
          <span className="coming-soon-badge">{t('accounts.coming_soon')}</span>
        </div>
      )}
      
      <div className="account-card-header" style={headerStyle}>
        <h2 className="account-card-title">{packageData.name}</h2>
        <div className="account-card-price">
          <img src={usdcIcon} alt="USDC" className="price-icon" />
          <span className="price-amount">{formatPrice(packageData.price)}</span>
        </div>
      </div>

      <div className="account-card-body">
        <div className="account-card-row">
          <span className="account-card-label">{t('accounts.get_fund8')}</span>
          <span className="account-card-value">{formatAmount(packageData.getFund8)} USDC</span>
        </div>

        <div className="account-card-row">
          <span className="account-card-label">{t('accounts.drawdown_limit')}</span>
          <span className="account-card-value">{packageData.drawdownLimit}</span>
        </div>

        <div className="account-card-row">
          <span className="account-card-label">{t('accounts.profit_ratio')}</span>
          <span className="account-card-value">{packageData.profitRatio}</span>
        </div>

        <div className="account-card-row">
          <span className="account-card-label">{t('accounts.monthly_min_target')}</span>
          <span className="account-card-value">{packageData.monthlyMinTarget}</span>
        </div>
      </div>

      <div className="account-card-footer">
        <button
          style={buttonStyle}
          onClick={() => packageData.isActive && onSelect(packageData)}
          disabled={!packageData.isActive}
        >
          {t('accounts.purchase')}
        </button>
      </div>
    </div>
  );
};

export default AccountCard;

